import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DataService} from "../../services/data.service";
import {HttpErrorResponse} from "@angular/common/http";
import {UtilService} from "../../services/util.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  loading = false;

  headerForm: FormGroup;
  showImpersonateText: boolean = false;
  dropDownOptions: object[] = [{label: "Broker Name", value: "brokername"}, {label: "Broker ID", value: "id"}, {label: "Sales Person", value: "salesperson"}];
  displayedColumns: any[] = [
    {field: 'brokerId', label: 'Broker ID'},
    {field: 'brokerName', label: 'Broker Name'},
    {field: 'brokerSalesPerson', label: 'Sales Person Name'},
    {field: 'brokerDescription', label: 'Description'},
    {field: 'riskSwing', label: 'Risk Swing'},
    {field: 'defaultBrokerPaymentOptions', label: 'Broker Payment Option'}
  ];
  dataSource;
  @ViewChild('adminTable') adminTable;

  constructor(public form: FormBuilder, public dataService: DataService, private utilService: UtilService, private route: Router) { }

  ngOnInit(): void {
    // this.getAdminData();
    this.headerForm = this.form.group({dropDownSelection: ['', Validators.required], searchValue: ['', Validators.required]})
    if(Object.keys(this.dataService.ImpersonateData).length) {
      // this.headerForm.setValue(this.dataService.ImpersonateData);
      this.showImpersonateText = true;
      // this.getImpersonateData();
      this.dataSource = [this.dataService.ImpersonateRowData];
      this.adminTable.initializeTable();
    }
  }
  getImpersonateData(){
      let self = this;
      this.loading = true;
      self.dataService.getBrokerAdminInfo(this.dropDownSelection, this.searchValue).subscribe((res: any) => {
        // this.showImpersonateText = true;
        if(this.dropDownSelection == 'id'){
          const {brokerSalesPerson: {salesPersonName}, riskSwing, defaultBrokerPaymentOptions} = res.anObjectTable1114
          res.brokerSalesPerson = salesPersonName;
          res.riskSwing = riskSwing;
          res.defaultBrokerPaymentOptions = defaultBrokerPaymentOptions;
          this.dataSource = [res];
        }else{
          res = res.map(item => {
            const {brokerSalesPerson: {salesPersonName}, riskSwing, defaultBrokerPaymentOptions} = item.anObjectTable1114
            item.brokerSalesPerson = salesPersonName;
            item.riskSwing = riskSwing;
            item.defaultBrokerPaymentOptions = defaultBrokerPaymentOptions;
            return item;
          })
          this.dataSource = res;
        }
        self.adminTable.initializeTable();
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.utilService.errorMessage('Fetch Failed')
      });
    }

    getDropdownLabel(id?: string){
      let selectedVal: any = this.dropDownOptions.filter((item: any) => item.value === this.headerForm.value.dropDownSelection)
      if(id)
        return selectedVal[0] ? selectedVal[0].label : ''
      else
        return selectedVal[0] ? "Search by " + selectedVal[0].label + "   ..." : "Search by ......"
    }

    get dropDownSelection(){
      return this.headerForm.value.dropDownSelection;
    }

    get searchValue(){
      return this.headerForm.value.searchValue;
    }

    dropDownSelectionChange(){
      this.headerForm.controls['searchValue'].setValue('');
      // this.search()
    }
    reset(){
      this.loading = true;
      this.dataService.resetBrokerImpersonate().subscribe(res => {
        this.loading = false;
        this.headerForm.reset();
        this.dataSource = [];
        this.dataService.setImpersonateDetails({});
        this.dataService.setImpersonateRowData({});
        this.showImpersonateText = false;
        setTimeout(this.adminTable.initializeTable);
        this.utilService.successMessage('Reset Successfully');
        localStorage.setItem("impersonation", "false");
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.utilService.errorMessage('Error while reset please try later');
      })
    }

  async rowClicked(row){
    this.dataService.setImpersonateDetails(this.headerForm.value);
    this.dataService.setImpersonateRowData(row);
    this.loading = true;
    await this.dataService.brokerImpersonate(row.brokerId).toPromise().then(res => {
      localStorage.setItem("impersonation", 'true');
      this.route.navigate(['/custom-deals']);
    }).catch((err: HttpErrorResponse) => {

    }).finally(() => {
      this.loading = false;
    })
  }

}
